import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Grid } from '@material-ui/core';

import { useAppParams } from '@klp/core/app/useAppParams';
import { ActionLink, Block, Heading } from '@klp/design';
import { Main } from '@klp/layout';

import { Message } from '../classes';
import type { IMessageInput } from '../classes';
import { MessageForm } from '../components';
import { MessageBoardRoutes } from '../config';
import { usePostMessageMutation } from '../rtkApi';

export const MessageAdd: React.FC = () => {
    const history = useHistory();
    const { messageId } = useAppParams();

    const [postMessage, { isLoading: saving, data: saveResult }] =
        usePostMessageMutation();

    const saved = saveResult?.message;

    useEffect(() => {
        if (saved) {
            history.push(MessageBoardRoutes.single(saved.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saved]);

    const onSubmit = async (event: React.FormEvent, values: IMessageInput) => {
        event.preventDefault();
        await postMessage(Message.parseObject(values));
    };

    const onCancel = () => {
        history.push(MessageBoardRoutes.single(messageId));
    };

    return (
        <Main>
            <Block paddingBottom="bulky">
                <ActionLink
                    actionType="linkBack"
                    translation="message.backButton"
                    href={MessageBoardRoutes.moduleRoute()}
                />
            </Block>
            <Grid container={true}>
                <Grid item={true} sm={10} md={10}>
                    <Heading translation="message.addMessage" />

                    <MessageForm
                        mode="add"
                        message={Message.empty()}
                        onSubmit={onSubmit}
                        onCancel={onCancel}
                        disabled={saving}
                        isLoading={saving}
                    />
                </Grid>
            </Grid>
        </Main>
    );
};
